import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const authApi = {
  getBrands: async (token: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetListBrandByAccount`,
      {},
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
